
import Vue from "vue";
import Home from "./views/Home.vue";
import { version } from "../package.json";

export default Vue.extend({
  name: "App",

  components: {
    Home
  },

  data: () => ({
    version
  })
});
